module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/calculator-item.component.css
// module id = ./src/app/components/calculator/calculator-item/calculator-item.component.css
// module chunks = main